/**
 * Messaging API Service
 * Handles all messaging/chat-related API calls
 */

import apiClient from '../apiClient';
import { ENDPOINTS } from '../endpoints';

/**
 * Get all conversations for current user
 */
export const getConversations = () =>
  apiClient.get(ENDPOINTS.MESSAGING.CONVERSATION);

/**
 * Get messages for a specific conversation
 */
export const getMessages = (conversationId, page = 0, size = 100) =>
  apiClient.get(`${ENDPOINTS.MESSAGING.CONVERSATION}/${conversationId}/message`, {
    params: { page, size, sort: 'createdAt,desc' }
  });

/**
 * Create a new conversation
 */
export const createConversation = (data) =>
  apiClient.post(ENDPOINTS.MESSAGING.CONVERSATION, data);

/**
 * Search conversations by query and type
 */
export const searchConversations = (query, searchType) =>
  apiClient.get(`${ENDPOINTS.MESSAGING.CONVERSATION}/search`, {
    params: { term: query, type: searchType }
  });

/**
 * Join a group conversation
 */
export const joinGroupMessages = (conversationId) =>
  apiClient.post(`${ENDPOINTS.MESSAGING.CONVERSATION}/conversation/${conversationId}/join`);

/**
 * Get unread message count
 */
export const getUnreadCount = () =>
  apiClient.get(ENDPOINTS.MESSAGING.MESSAGES_UNREAD_COUNT);

/**
 * Mark a message as read
 */
export const markAsRead = (messageId) =>
  apiClient.put(`${ENDPOINTS.MESSAGING.MESSAGES}/${messageId}/read`);

